const locale = {
  placeholder: 'Välj tid',
};

export default locale;
